"use client"
import styled from "@emotion/styled"
import IconButton from "@mui/material/IconButton"
import InputBase from "@mui/material/InputBase"
import Paper from "@mui/material/Paper"
import { ChangeEvent, KeyboardEvent } from "react"
import SearchInputIcon from "../icons/SearchInputIcon"
import { sharedColors } from "../theme/colors"

const StyledInputBase = styled(InputBase)`
  align-self: center;
  color: ${sharedColors.heroBgFallback};
  width: 100%;
  & .MuiInputBase-input {
    letter-spacing: -0.36px;
    font-size: 18px;
    line-height: 150%;
    font-family: var(--narkis) !important;
    font-weight: 300;
    &::placeholder {
      letter-spacing: -0.36px;
      font-size: 18px;
      line-height: 150%;
      font-family: var(--narkis) !important;
      opacity: 1;
      font-weight: 300;
    }
  }
`

const StyledPaper = styled(Paper)`
  display: flex;
  width: 518px;
  height: 56px;
  padding: 8px 8px 8px 16px;
  align-items: center;
  gap: 6px;
  justify-content: flex-start;
  border-radius: 37px;
  background-color: ${sharedColors.white};
  box-shadow: 0 0 16px 0 rgba(0, 38, 83, 0.12);
  max-width: 100%;
`

const StyledIconButton = styled(IconButton)`
  align-self: center;
  padding: 0;
  color: ${sharedColors.propBlue};
  order: -1;
`

type Props = {
  placeholder: string
  className?: string
  value?: string
  // eslint-disable-next-line no-unused-vars
  onChange?: (value: string) => void
  // eslint-disable-next-line no-unused-vars
  onKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void
  onIconClick?: () => void
}

function SearchInput({
  placeholder,
  className,
  value: inputValue,
  onChange,
  onKeyDown,
  onIconClick,
}: Props) {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.value)
  }

  return (
    <StyledPaper className={className}>
      <StyledInputBase
        placeholder={placeholder}
        inputProps={{ "aria-label": placeholder }}
        value={inputValue}
        onChange={handleChange}
        onKeyDown={onKeyDown}
      />
      <StyledIconButton aria-label="search" onClick={onIconClick}>
        <SearchInputIcon />
      </StyledIconButton>
    </StyledPaper>
  )
}

export default SearchInput
